import { MoneyScaled, removeScaleFromMoney } from '@quickbit/qb-design-system';

export const PROOF_OF_OWNERSHIP_THRESHOLD_EUR = 1000;

/**
 * Checks if the EUR amount exceeds the threshold for requiring proof of ownership.
 * Uses strictly greater than (>) operator, so exactly 1000 EUR returns false.
 *
 * @param euroAmount - The amount in EUR (MoneyScaled format)
 * @returns true if amount > 1000 EUR, false otherwise
 */
export const exceedsProofOfOwnershipThreshold = (
  euroAmount: MoneyScaled
): boolean => {
  if (euroAmount.currencyCode !== 'EUR') {
    console.warn(
      `Expected EUR currency but got ${euroAmount.currencyCode}. Defaulting to false.`
    );
    return false;
  }

  return removeScaleFromMoney(euroAmount) > PROOF_OF_OWNERSHIP_THRESHOLD_EUR;
};
